module.exports = __webpack_public_path__ + "img/青海省人民医院.acfc0c41.png";